import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiError } from '../../lib/api.ts';
import { SiteLayout } from '../../components/SiteLayout.tsx';

export function ForgotPage() {
  const [email, setEmail] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      await api.kontoGlemtPassord(email);
      setDone(true);
    } catch (error) {
      setErr((error as ApiError).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <SiteLayout>
      <main className="flex justify-center px-4 py-12 sm:py-16">
        <div className="w-full max-w-sm bg-slate-900/60 border border-slate-800 rounded-2xl p-6">
          <h1 className="text-xl font-bold text-center mb-5">Glemt passord</h1>

          {done ? (
            <div className="text-center">
              <p className="text-sm text-slate-400 mb-5">
                Finnes det en konto på denne e-posten, har vi sendt en lenke for å sette nytt passord.
                Sjekk innboksen (gyldig i 2 timer).
              </p>
              <Link to="/logg-inn" className="text-sm text-sky-400 hover:text-sky-300">
                ← Til innlogging
              </Link>
            </div>
          ) : (
            <form onSubmit={submit}>
              {err && (
                <div className="mb-4 text-red-300 bg-red-900/30 border border-red-800 rounded-lg p-3 text-sm">
                  {err}
                </div>
              )}
              <label className="block text-xs text-slate-400 mb-1">E-post</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
                autoFocus
                className="w-full mb-5 px-3 py-2 bg-slate-950 border border-slate-700 rounded-lg"
              />
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-sky-600 hover:bg-sky-500 py-3 rounded-lg font-semibold disabled:opacity-60"
              >
                {loading ? 'Sender…' : 'Send lenke'}
              </button>
              <div className="mt-4 text-center">
                <Link to="/logg-inn" className="text-sm text-slate-400 hover:text-slate-200">
                  ← Tilbake
                </Link>
              </div>
            </form>
          )}
        </div>
      </main>
    </SiteLayout>
  );
}
